import draftActions from './draft-actions';

export default {
    setIsPropertyEditMode: isPropertyEditMode => ({
        type: 'SET_IS_PROPERTY_EDIT_MODE',
        payload: isPropertyEditMode
    }),
    setCreationType: creationType => ({
        type: 'SET_CREATION_TYPE',
        payload: creationType
    }),
    showAllErrors: () => ({
        type: 'SHOW_ALL_ERRORS'
    }),
    hideAllErrors: () => ({
        type: 'HIDE_ALL_ERRORS'
    }),
    setIsEditOfPublishedItem: isEditOfPublishedItem => ({
        type: 'SET_IS_EDIT_OF_PUBLISHED_ITEM',
        payload: isEditOfPublishedItem
    }),

    setCategoryRestriction: restriction => dispatch => {
        dispatch({
            type: 'SET_CATEGORY_RESTRICTION',
            payload: restriction
        });
        dispatch(draftActions.updateItemConditionRestrictionForCategory());
    },
    toggleModal: modalId => ({
        type: 'TOGGLE_MODAL',
        payload: modalId
    }),
    showModal: (modalId, modalData) => ({
        type: 'SHOW_MODAL',
        modalId: modalId,
        modalData: modalData
    }),
    hideModal: () => ({
        type: 'HIDE_MODAL'
    }),
    reset: () => ({
        type: 'RESET_SYI'
    }),
    enableAutoSave: () => ({
        type: 'ENABLE_AUTOSAVE'
    }),
    disableAutoSave: () => ({
        type: 'DISABLE_AUTOSAVE'
    })
};
